const NUMBER_TYPE_VALUES = ['shortcode', 'tollfree', 'local', 'hosted'];

export const getNumberTypeOptions = () =>
    NUMBER_TYPE_VALUES.map((value) => ({
        label: formatNumberType(value),
        value: value,
    }));

export const formatNumberType = (numberType) => {
    switch (numberType) {
        case 'shortcode':
            return 'Short Code';
        case 'tollfree':
            return 'Toll Free';
        case 'local':
            return 'Long Code';
        case 'hosted':
            return 'Hosted';
        default:
            return 'Unknown';
    }
};

export const formatVendor = (vendor) => {
    switch (vendor) {
        case 'bandwidth':
            return 'Bandwidth';
        case 'twilio':
            return 'Twilio';
        default:
            return 'Unknown';
    }
};
